import GetItemByIntegerIdViewModel from '@/core/view-models/GetItemByIntegerIdViewModel';
import LivestreamProductFactory from '../factories/LivestreamProductFactory';
import GetLivestreamProductResult from '../models/GetLivestreamProductResult';

export default class GetLivestreamProductBydIdUseCase {
    private livestreamProductRepo = LivestreamProductFactory.makeRepo();
    private livestreamProductMapper = LivestreamProductFactory.makeMapper();

    public async invoke(model: GetItemByIntegerIdViewModel) {
        let result = new GetLivestreamProductResult();
        const validateResult = model.validate();
        if (validateResult.success === false) {
            result = result.copyExceptData(validateResult);
            return result;
        }

        const getDataResult = await this.livestreamProductRepo.get(model.getId());
        if (getDataResult.success === false) {
            result = result.copyExceptData(getDataResult);
            return result;
        }

        result.data = this.livestreamProductMapper.mapFromApiToEntity(getDataResult.data);
        result.success = result.data !== null;
        if (result.success) {
            result.message = 'Get livestream product by id success';
        } else {
            result.message = 'Get livestream product by id failed';
        }

        return result;
    }

    public invokeByParams(id: number) {
        const model = new GetItemByIntegerIdViewModel();
        model.setId(id);

        return this.invoke(model);
    }
}
